module.exports = __webpack_public_path__ + "img/symbol_7.e76df947.png";